import TaskTabs from "components/pages/tasks/tabs/TaskTabs";
import TaskTableWrapper from "components/pages/tasks/TaskTableWrapper";
import useTasks from "./useTasks";

const Tasks = ({ selectedTab }) => {
  const { isLoading } = useTasks(selectedTab);
  return (
    <div>
      <TaskTabs selectedTab={selectedTab} isLoading={isLoading} />
      <TaskTableWrapper selectedTab={selectedTab} isLoading={isLoading} />
    </div>
  );
};

export default Tasks;
